export function filterRegex(
  prefix: string,
  value: string,
  caseSensitive: boolean = false
): Record<string, string> {
  if (typeof value !== 'string' || !value.length) {
    return {};
  }

  return {
    [`${prefix}[$regex]`]: value.replace(/[\\^$*+?.()|[\]{}]/g, '\\$&'),
    [`${prefix}[$options]`]: caseSensitive ? '' : 'i',
  };
}

export function filterText(text: string): Record<string, string> {
  if (typeof text !== 'string' || !text.length) {
    return {};
  }

  return {
    [`filter[$text][$search]`]: text,
  };
}

export function page({ offset, limit }: { offset: number; limit: number }) {
  return {
    'page[offset]': Number.isFinite(offset) ? offset : 0,
    'page[limit]': limit,
  };
}

export function include(includes: string[]) {
  return {
    'include[]': includes,
  };
}

export function sort(field: string) {
  return {
    'sort[]': field,
  };
}
